// extracted by mini-css-extract-plugin
module.exports = {"figureCaption":"ImageReference_figureCaption__28isS","figureCaptionDiv":"ImageReference_figureCaptionDiv__3eRQf"};